import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useLocation, useNavigate } from "react-router-dom";
import { Chip, Grid, IconButton, Avatar, Tooltip } from "@mui/material";
import { Close as CloseIcon, Check as CheckIcon } from "@mui/icons-material";

import SortBy from "./SortBy";
import pages from "../../../constants/pages";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";
import { Search } from "../../../components";
import Categorize from "../../campaign components/campaign list components/superadmin list components/Categorize";
import FilterByAgency from "./FilterByAgency";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple};
  color: ${colors.purple};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const Check = styled(CheckIcon)`
  color: #28967e;
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

const Close = styled(CloseIcon)`
  color: #d32f2f;
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

export default function List({
  SortBy,
  setSortBy,
  brands,
  setPage,
  setSearchKey,
  loading,
  categorize,
  setCategorize,
  platformID,
  setFilterByAgency,
  filterByAgency,
}) {
  const { state } = useLocation();
  const navigate = useNavigate();
  let columns = [
    { name: "", label: "" },

    {
      name: "brand_name",
      label: "Brand Name",
    },

    {
      name: "brand_verification_status",
      label: "Brand Status",
    },

    { name: "agency_name", label: "Agency Name" },

    { name: "platform_source", label: "Platform Source" },

    {
      name: "api_partner",
      label: "API Partner",
    },
    { name: "brand_detail", label: "Brand Detail" },
    { name: "is_company_detail_filled", label: "Company Detail" },
    { name: "is_sign_agreement", label: "Agreement Signed" },
    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "") {
      return (
        <Avatar
          onClick={() => handleBrandNavigation(row.brand_id)}
          src={row.logo}
          style={{ height: "40px", width: "40px", cursor: "pointer" }}
        />
      );
    }

    if (col.name === "agency_name") {
      return value ? value : "-";
    }

    if (col.name === "api_partner") {
      return value ? value : "-";
    }

    if (col.name === "brand_detail") {
      return <Check />;
    }

    if (col.name === "is_company_detail_filled") {
      return row.is_company_detail_filled === 1 ? <Check /> : <Close />;
    }

    if (col.name === "is_sign_agreement") {
      return row.is_sign_agreement ? <Check /> : <Close />;
    }

    if (col.name === "brand_verification_status") {
      let color;
      let label;
      let background;
      if (value === 0) {
        color = colors.warning;
        background = colors.lightWarning;
        label = "Unverified";
      }

      if (value === 1) {
        color = colors.success;
        background = colors.lightSuccess;
        label = "Verified";
      }

      if (value === 2) {
        color = colors.error;
        background = colors.lightError;
        label = "Rejected";
      }

      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: background,
            color: color,
          }}
          label={label}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Campaign">
            <Icon>
              <CgEye
                onClick={() => handleBrandNavigation(row.brand_id, "view")}
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar
              platformID={platformID}
              setFilterByAgency={setFilterByAgency}
              filterByAgency={filterByAgency}
              categorize={categorize}
              setCategorize={setCategorize}
              SortBy={SortBy}
              setSortBy={setSortBy}
              setPage={setPage}
              setSearchKey={setSearchKey}
            />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={brands}
        />
      </Grid>
    </Grid>
  );

  function handleBrandNavigation(brandID) {
    navigate(pages.unverifiedPageDetails.route + "?brandID=" + brandID, {
      state: { component: state?.component },
    });
  }
}

export function ToolBar({
  categorize,
  setCategorize,
  setPage,
  setSearchKey,
  sortBy,
  setSortBy,
  platformID,
  setFilterByAgency,
  filterByAgency,
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />

        <Categorize
          categorize={categorize}
          setCategorize={setCategorize}
          setPage={setPage}
        />

        <FilterByAgency
          categorize={categorize}
          setPage={setPage}
          platformID={platformID}
          setFilterByAgency={setFilterByAgency}
          filterByAgency={filterByAgency}
        />

        <SortBy setPage={setPage} sortBy={sortBy} setSortBy={setSortBy} />
      </div>
    </div>
  );
}
